import {useGetAllBAU,useDeleteIndexManaging} from '../../Hooks/Index'
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom1/DYCustom1';
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import React, { useState,useEffect,useMemo } from 'react';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import {Grid,Box,Typography, Button, Tooltip, IconButton, Dialog, DialogTitle, DialogActions} from '@mui/material';
import CreateIndexManaging from '../CreateIndexManaging/CreateIndexManaging';
import { DataGrid, GridColDef, GridCellParams } from "@mui/x-data-grid";
import CommentModal from "../../../TenantDash/LComponents/AllTenantDash/AnotherComponent ";
import EditIndexManaging from '../EditIndexManaging/EditIndexManaging';
import { GridValueFormatterParams } from '@mui/x-data-grid';
import {
  GridDeleteIcon,
  
} from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import UploadBAUFile from '../UploadBAUFile/UploadBAUFile';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useGetBank } from '../../../IndexBank/Hooks/Index';
import { Star } from "@mui/icons-material";
import AddIndex from '../../../IndexBank/LComponents/AddIndex/AddIndex';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const AllIndexManaging = ({periodsData,periodId}:any) => {
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه

  // const [addEvalAsyncData, setAddEvalAsyncData] = useState<any>(null);
  // const [SuccessState, setSuccessState] = useState<boolean>(true);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showAddLicense1, setShowAddLicense1] = useState<boolean>(false);
  const{mutate:deleteTeam/*,isError,isSuccess*/,data:deleteData}=useDeleteIndexManaging();
  const [krId, setKrId] = useState('');
  const [deleteId, SetDeleteKrId] = useState('');
  const [Ids, setIds] = useState(null);
  const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
    localStorage.getItem("indexSelectionModel")
  );
  // const [value, setValue] = React.useState(0);
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {data:dataIndex,isLoading:dataLoading,isError:dataError,refetch:getAgain}=useGetAllBAU(tenantId,periodId);
  const {data:databank,isLoading:dataLoadingbank,isError:dataErrorbank}=useGetBank(tenantId);
  const{data,metaData} : any = dataIndex  || {};
  const{appStatusCode}=metaData  || {};
  const [open, setOpen] = React.useState(false);

  const handleClos = () => {
      setOpen(false);
  };
  
  const initialAddLicense1 = (): void => {
    setShowAddLicense1((prev) => !prev);
  };

  const initialDelete=(iddd:string)=>{
    let deleteBody={
    id:iddd}
    deleteTeam(deleteBody)
    }

    const initialAddToTenantList=()=>{
      let deleteBody={
      ids:Ids}
      deleteTeam(deleteBody)
      }

      const initialAddToMyList=()=>{
        let deleteBody={
        ids:Ids}
        deleteTeam(deleteBody)
        }

  // useEffect(() => {
  //   if (addEvalAsyncData) {
  //     setSuccessState(true);
  //   }
  // }, [addEvalAsyncData]);

  useEffect(() => {
    if (deleteData) {
      if (deleteData?.data.isSuccess) {
        setShowToastMessage(true);
        SetIsSuccess(true);
        SetTMessage(deleteData?.data.metaData.message);
      } else {
        setShowToastMessage(true);
        SetIsSuccess(false);
        SetTMessage(deleteData?.data.metaData.message);
      }
    }
  }, [deleteData]);

  // useEffect(() => {
  //   const indexSelectionModel = localStorage.getItem("indexSelectionModel");
  //   if (indexSelectionModel) {
  //     setIndexSelectionModel(indexSelectionModel);
  //   }
  // }, [addEvalAsyncData]);
  const tenantsColumns: any = useMemo(()=>[
    {
      field: "rowid",
      headerName: "ردیف",
      width: 40,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    },
      // { field: 'name',
      //   align:'left',
      //   headerName: 'شرح',
      //   headerAlign:'center',
      //   sortable:false,
      //   // wrap:'wrap',
      //   // width: 320,
      //   flex:1
      // },
      {
        field: "name",
        headerName: "شرح",
        flex: 1,
        sortable: false,
        headerAlign: "center",
        align: "left",
        renderCell: (params: GridCellParams) => {
          const value = params.value as React.ReactNode; 
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {params.row.isStrategic && (
                <Star style={{ color: "#FFD700", fontSize: "20px" }} />
              )}
              <span>{value}</span>
            </div>
          );
        },
      },
      { field: 'team',
      align:'center',
      headerName: 'تیم',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:90
      },
      { field: 'responsible',
        align:'center',
        headerName: 'مسئول',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90
        }
      ,
      {
        field: "measurementUnit",
        headerName: "معیار سنجش",
        align: "center",
        headerAlign: "center",
        sortable: false,
        minWidth: 60,
        hideable: true,
        hide: true,
        fontsize: "14px",
        renderCell: ({ value, row }: any) => {
          return (
            <div
              onDoubleClick={() => {
                if (row && row.id) {
                  setKrId(row.id);
                  //setShowAddEvalModal(true); // باز کردن مدال
                }
              }}
              //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {value.length > 40 ? (
                  <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                    {value}
                  </Tooltip>
                ) : (
                  <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
                )}
              </Box>
            </div>
          );
        },
      },
      {
        field: "reportingPeriod",
        headerName: "منطق گزارش دهی",
        align: "center",
        headerAlign: "center",
        sortable: false,
        minWidth: 60,
        hideable: true,
        hide: true,
        fontsize: "14px",
        renderCell: ({ value, row }: any) => {
          return (
            <div
              onDoubleClick={() => {
                if (row && row.id) {
                  setKrId(row.id);
                  //setShowAddEvalModal(true); // باز کردن مدال
                }
              }}
              //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {value.length > 40 ? (
                  <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                    {value}
                  </Tooltip>
                ) : (
                  <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
                )}
              </Box>
            </div>
          );
        },
      },
      { field: 'okrState',
      align:'center',
      headerName: 'وضعیت',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width:85,
      renderCell: (par: any) => {
        let value: string = par?.row?.okrState;
        switch (value) {
          case "فعال":
            return (
              <Box 
              bgcolor={"#D5f7D4"}
              sx={{ width: "100%", textAlign: "center",borderRadius:2 }}>
                  <Typography
              color={"green"}
              fontSize={"0.8rem"}
            >
              {" "}
              {"فعال"}
            </Typography>
              </Box>
            );
            break;

          case "پیش نویس":
            return (
              <Box 
              bgcolor={"#bfd3f5"}
              sx={{ width: "100%", textAlign: "center",borderRadius:2  }}>
                 <Typography
              color={"#3a82fc"}
              fontSize={"0.8rem"}
            >
              {" "}
              {"پیش نویس"}
            </Typography>
              </Box>
            );
            break;

          default:
            return null;
            break;
        }
      },
      }
      ,
      {
        field: 'startValue',
        headerName: 'شروع',
        width: 90,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (params: GridValueFormatterParams) => {
          const value = params.value as number; // گرفتن مقدار سلول
          // بررسی اینکه آیا مقدار منفی است یا خیر
          return value < 0 ? `${Math.abs(value)}-` : `${value}`; // نمایش عدد منفی در انتها
        },
      }
      ,
      { field: 'lastValueO',
      align:'center',
      headerName: 'آخرین مقدار',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:80,
       renderCell: (par: any) => {
        let lastValue: any = par?.row?.lastValueO;
        let lowerLimit: any = par?.row?.lowerLimitO;
        let upperLimit: any = par?.row?.upperLimitO;
        return (
          lastValue !== null ?
          <Box 
          bgcolor={lastValue >= lowerLimit && lastValue <= upperLimit ? "#D5f7D4" : '#FFEEE5 '}
          sx={{ width: "100%", textAlign: "center",borderRadius:2 }}>
          {/* <Typography
          color={lastValue >= lowerLimit && lastValue <= upperLimit ? "#125610" : '#993600 '}
          fontSize={"0.8rem"}
        >
          {lastValue}
        </Typography> */}
        <Typography
  color={lastValue >= lowerLimit && lastValue <= upperLimit ? "#125610" : '#993600 '}
  fontSize={"0.8rem"}
>
  {lastValue < 0 ? `${Math.abs(lastValue)}-` : lastValue}
</Typography>

          </Box>:
          <Box>-</Box>
        );
      },
      }
      ,
      { field: 'lowerLimitO',
      align:'center',
      headerName: 'حد پایین',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width:70,
      valueFormatter: (params: GridValueFormatterParams) => {
        const value = params.value as number; // گرفتن مقدار سلول
        // بررسی اینکه آیا مقدار منفی است یا خیر
        return value < 0 ? `${Math.abs(value)}-` : `${value}`; // نمایش عدد منفی در انتها
      },
      }
      ,
      { field: 'upperLimitO',
      align:'center',
      headerName: 'حد بالا',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:70,
       valueFormatter: (params: GridValueFormatterParams) => {
        const value = params.value as number; // گرفتن مقدار سلول
        // بررسی اینکه آیا مقدار منفی است یا خیر
        return value < 0 ? `${Math.abs(value)}-` : `${value}`; // نمایش عدد منفی در انتها
      },
      }
      ,
      {
        field: 'statusO',
        align: 'center',
        headerName: 'وضعیت شاخص',
        headerAlign: 'center',
        sortable: false,
        wrap: 'wrap',
        width: 100,
        renderCell: (par: any) => {
          const lastValue: any = par?.row?.lastValueO;
          const lowerLimit: any = par?.row?.lowerLimitO;
          const upperLimit: any = par?.row?.upperLimitO;
      
          const isWithinLimits =
            lastValue !== null &&
            lastValue >= lowerLimit &&
            lastValue <= upperLimit;
      
          return (
            <Box
              bgcolor={isWithinLimits ? "#D5f7D4" : "#FFEEE5"}
              sx={{
                width: "100%",
                textAlign: "center",
                borderRadius: 2,
                padding: "2px",
              }}
            >
              <Typography
                color={isWithinLimits ? "#125610" : "#993600"}
                fontSize={"0.7rem"}
              >
                {isWithinLimits ? "بین حدود" : "خارج از حدود"}
              </Typography>
            </Box>
          );
        },
      },     
      { field: 'updateBy',
      align:'center',
      headerName: 'بروزرسانی کننده',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:110
      }
      ,
      { field: 'updateDate',
      align:'center',
      headerName: 'رسانی',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:105
      }
      ,
      { field: 'upperCount',
      align:'center',
      headerName: 'تعداد ارزیابی های بین حد بالا و پایین',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width:60
      }
      ,
      { field: 'lowerCount',
      align:'center',
      headerName: 'تعداد ارزیابی های خارج از حد بالا و پایین',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width:60
      }
      ,
      { field: 'count',
        align:'center',
        headerName: 'تعداد دفعات فاقد ارزیابی',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
        width:60
        }
        ,
      {
        field: "comment",
        headerName: "نظرات",
        align: "center",
        headerAlign: "center",
        sortable: false,
        minWidth: 60,
        fontsize: "14px",
        renderCell: ( par : any) => {
          if(par !== undefined && par !== null){
          let idd: string = par?.row?.id;
          let namee: string = par?.row?.name;
          let commentCount: number = par?.row?.commentCount;
          return (
            <Box display={"flex"} justifyContent={"end"}>
            <CommentModal id={idd} name={namee} commentCount={commentCount}/>
            </Box>
        )
          }
        },
      },
      {
        field: "delete",
        headerName: "",
        align: "center",
        headerAlign: "center",
        sortable: false,
        maxWidth: 5,
        fontsize: "10px",
        renderCell: ( par : any) => {
          let idd: string = par?.row?.id;
          return (
            <Box display={"flex"} justifyContent={"center"}>
              {/* <Tooltip  title="ویرایش">
            <IconButton onClick={()=>{
                  initialDelete(idd);
              }}   >
              <GridDeleteIcon />
            </IconButton>
          </Tooltip> */}
          <Button
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: 'red',    // متن قرمز
                }}
                variant="text"
                startIcon={<GridDeleteIcon />}
                onClick={() => {
                  initialDelete(idd);
                  // console.log('a');
                  // SetDeleteKrId(idd);
                  // console.log('b');
                  // setOpen(true);
                  // console.log('c');
                }}
          >
          </Button>
         </Box>
          )
        },
      },
      {
        field: "edit",
        headerName: "",
        align: "center",
        headerAlign: "center",
        sortable: false,
        maxWidth: 5,
        fontsize: "10px",
        renderCell: ( par : any) => {
          let idd: string = par?.row?.id;
          return (
          <Box display={"flex"} justifyContent={"center"}>
          <Tooltip  title="ویرایش">
            <IconButton onClick={()=>{
                  setHistoryModal(true);
                  setKrId(idd);
              }}   >
              <EditIcon color='primary'   />
            </IconButton>
          </Tooltip>
          </Box>
          )
        },
      },
  ],[]);
  
  const [showAddLicense2, setShowAddLicense2] = useState<boolean>(false);
  const [showAddLicense, setShowAddLicense] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [krRowData, setKrRowData] = useState(null);

  <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClos}
      aria-labelledby="responsive-dialog-title"
      >
      <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
        {"آیا از حذف اطمینان دارید؟"}
      </DialogTitle>
      <DialogActions>
        <Button autoFocus onClick={handleClos}>
          <Typography color={'red'}>انصراف</Typography>
        </Button>
        <Button 
          onClick={() => {
            initialDelete(deleteId);
            handleClos();
          }}
          autoFocus
        >
          <Typography color={'#00387C'}>تایید</Typography>
        </Button>
    </DialogActions>
    </Dialog>


  const renderContent=()=>{
    
    if (dataLoading) {
      return (<Box  width={'100%'} py={16}   >
        <CircularProgress   />
      </Box>)
    }
    else if(appStatusCode === 7){
      return (<Box  width={'100%'} py={16}   >
         <Typography variant='body1' textAlign={'center'} fontSize={'20px'} fontWeight={700}>
         شما دسترسی به این قسمت را ندارید و باید لایسنس خود را ارتقا دهید
    </Typography>
      </Box>)
    }
    else {
      return <>
       <DyDataGridCustom
     rowHeight={10}
     data={dataError || dataLoading ? []:data }
     columns={tenantsColumns || []}
     hideFooter={false}
    //  selectionModel={[]}
    //  initialOnRowClick={()=>{}}
     additionalToolbar={true}
     setSelectionModel={setIndexSelectionModel}
     setShowHistory={() =>{}}
     initialOnRowClick={setKrRowData}
     setSpecialId={setKrId}
     initialDelete={() =>{}}
     setSelectedIds={setIds}
     initialAddToTenantList = {initialAddToTenantList}
     initialAddToMyList={initialAddToMyList}
     /></>
    }
  }

  const initialAddLicense = (): void => {
    setShowAddLicense((prev) => !prev);
  };

  const initialAddLicense2 = (): void => {
    setShowAddLicense2((prev) => !prev);
  };

  return (
    <>
    <Grid  sx={{bgcolor:'#F9F9F9',width:'100% !important',padding:'0px !important'}}   >
     <Grid item xs={12}   >
      {
        appStatusCode !== 7 && (<Box py={1} display={'flex'} justifyContent={'end'}>
          <button
            onClick={
              (e: React.MouseEvent<HTMLElement>) =>
              initialAddLicense()
            }
            className={`btn px-6  text-xs font-thin text-white bg-[#00387c]
              btn-sm rounded-md m-2`}
              >
            ایجاد شاخص پایش (BAU)
          </button>
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              initialAddLicense2()
            }
            className={`btn px-6  text-xs font-thin text-white bg-[#00387c]
               btn-sm rounded-md m-2`}
          >
            ایجاد شاخص
          </button>
          <button
            onClick={
              (e: React.MouseEvent<HTMLElement>) =>
              initialAddLicense1()
            }
            className={`btn px-6  text-xs font-thin text-white bg-[#00387c]
              btn-sm rounded-md m-2`}
              >
            عملیات اکسل
          </button>
          </Box> )
            }
            <div>
          <ModalLyt
            showModal={showAddLicense}
            setShowModal={setShowAddLicense}
            width={isMobile ? '350px' : '1000px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            height={700}
            title={"شاخص پایش(BAU)"}
          >
            <CreateIndexManaging
              periodsData={periodsData}
              bauData={data}
              onSuccess={getAgain}
              perId={periodId}
              setShowToastMessage={setShowToastMessage}
              setShowToastMessage2={setShowToastMessage2}
              access={true}
              onClose={setShowAddLicense}
            />
          </ModalLyt>
          <ModalLyt
            showModal={showAddLicense2}
            setShowModal={setShowAddLicense2}
             height={700}
            width={isMobile ? '350px' : '700px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"شاخص"}
          >
            <AddIndex
              onSuccess={getAgain}
              setShowToastMessage={setShowToastMessage}
              setShowToastMessage2 ={setShowToastMessage2}
              access={databank}
              onClose={setShowAddLicense2}
            />
          </ModalLyt>
          <ModalLyt
            showModal={showAddLicense1}
            setShowModal={setShowAddLicense1}
            width={isMobile ? '350px' : '1000px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            height={700}
            title={"عملیات اکسل"}
          >
            <UploadBAUFile
              // periodsData={periodsData}
              bauData={data}
              onSuccess={getAgain}
              // perId={periodId}
              periodId={periodId}
              getAgain={getAgain}
              setShowToastMessage={setShowToastMessage}
              setShowToastMessage2={setShowToastMessage2}
              access={true}
              onClose={setShowAddLicense1}
            />
          </ModalLyt>
     </div>
     </Grid>
     <Grid item xs={12}   >
     <Box textAlign={'center'}  mx={1} borderRadius={2} boxShadow={2} bgcolor={'white'} my={1} py={dataLoading?8:3}   >
    {
      renderContent()
    }
     </Box>
     {historyModal && (
          <ModalLyt
            // width={1000}
            width={isMobile ? '350px' : '1000px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            height={700}
            title={"ویرایش"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <EditIndexManaging
            periodsData={periodsData}
            onSuccess={getAgain}
            perId={periodId}
            bauData={data}
            id={krId}
            setShowToastMessage={setShowToastMessage}
            setShowToastMessage2={setShowToastMessage2}
            access={true}
            onClose={setHistoryModal}
            />
          </ModalLyt>
      )}
     </Grid>
     {showToastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {showToastMessage2 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
    </Grid>
    </>
  )
}

export default AllIndexManaging
